import React from 'react';
import {login_pattern1, login_pattern2} from '../../../../assets/images';
import {content,metric_content} from '../../../../constants/loginContent';

const LeftPanel = ({width = 'w-3/5'}) => {
  return (
    <div
      className={`${width} bg-blue-800 pt-24 pl-32 text-white`}
      style={{
        background: `url(${login_pattern1})  no-repeat top right, url(${login_pattern2}) no-repeat bottom left`,
        backgroundColor: '#4B5563',
      }}
    >
      <p
        className='text-4xl font-bold mb-0 leading-none inline-block'
        style={{color: '#FBCE7A'}}
      >
        Data Vue<span className="text-sm align-top">TM</span>
      </p>
      <p className='text-2xl font-semibold mb-0 mt-4 mr-32 leading-normal' style={{width: '567px'}}>
        Knowing the “health” of your “health programs” was never so easy
      </p>

      <div className='mt-12' style={{ width: '70%' }}>
        {content.map((item, index) => {
          return (
            <div className='flex items-center mt-8' key={`${item}`+ index}>
              <img src={item.image} alt='prefix_icon' className='mr-5' />
              <p className='mb-0 text-lg'>{item.text}</p>
            </div>
          );
        })}
      </div>

      <div className='mt-20 flex'>
        {metric_content.map((item, index) => {
          return (
            <div className={'flex flex-col w-1/3' + (metric_content.length - 1 === index ? ' mr-14' : ' mr-16')} style={{ width :  metric_content.length -1 === index ? '178px': '186px'}} key={`${item}`+ index}>
              <span className='font-bold text-4xl'>{index === 1 && '₹ '}<span className='font-bold tracking-wide'>{item.heading}</span></span>
              <p className={'text-base mb-0'+ (index === 1 ? ' pr-9':'')}>{item.body}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LeftPanel;